export default [
  {
    path: '/customers/:id',
    name: 'CustomerRetrieveUpdate',
    component: () => import(/* webpackChunkName: "customers" */ '@/views/customer/CustomerRetrieveUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'CustomerListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Cliente'
    }
  },
  {
    path: '/customers',
    name: 'CustomerListCreate',
    component: () => import(/* webpackChunkName: "customers" */ '@/views/customer/CustomerListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'CustomerListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Clientes'
    }
  },
  {
    path: '/contacts/:id',
    name: 'ContactRetrieveUpdate',
    component: () => import(/* webpackChunkName: "customers" */ '@/views/customer/ContactRetrieveUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'CustomerListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Persona'
    }
  },
  {
    path: '/contacts',
    name: 'ContactListCreate',
    component: () => import(/* webpackChunkName: "customers" */ '@/views/customer/ContactListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'CustomerListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Personas'
    }
  }
]